import { useEffect, useState } from 'react'

import { type ICommonField } from '@/app/types/common'
import { type ICompanyProgramItem } from '@/app/types/dmsTypes'

import { emptyProgram, type TextAreaEvent, type InputEvent } from '../../../helper'

interface IParams {
    data?: ICompanyProgramItem
}

export const useFields = (params: IParams) => {
    const { data } = params
    const _data: ICompanyProgramItem = data || emptyProgram

    const initialName: ICommonField = {
        name: 'Наименование программы',
        value: _data.name,
        error: null,
        isTouched: false,
        placeholder: 'Наименование программы'
    }

    const initialDescription: ICommonField = {
        name: 'Полное описание программы',
        value: _data.description,
        error: null,
        isTouched: false,
        placeholder: 'Полное описание программы'
    }

    const [name, setName] = useState<ICommonField>(initialName)
    const [description, setDescription] = useState<ICommonField>(initialDescription)

    const onChangeName = (e: InputEvent) => setName((prev) => ({ ...prev, value: e.target.value }))
    const onChangeDescription = (e: TextAreaEvent) => setDescription((prev) => ({ ...prev, value: e.target.value }))

    const onSetIsTouchedName = () => setName((prev) => ({ ...prev, isTouched: true }))
    const onSetIsTouchedDescription = () => setDescription((prev) => ({ ...prev, isTouched: true }))

    useEffect(() => {
        if (!name.value) {
            setName((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else if (/[,] ?|[,]|[;]|[+]/gi.test(name.value)) {
            setName((prev) => ({ ...prev, error: 'Валидация не прох' }))
        } else {
            setName((prev) => ({ ...prev, error: null }))
        }

        if (!description.value) {
            setDescription((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setDescription((prev) => ({ ...prev, error: null }))
        }
    }, [name.value, setName, description.value, setDescription])

    const onCheckIsToched = (): boolean => {
        if (name.isTouched || description.isTouched) {
            return true
        }
        return false
    }

    const onSetTouchAll = () => {
        onSetIsTouchedName()
        onSetIsTouchedDescription()
    }

    return {
        name,
        onChangeName,
        onSetIsTouchedName,
        //
        description,
        onChangeDescription,
        onSetIsTouchedDescription,
        //
        isSomeToched: onCheckIsToched(),
        onSetTouchAll
    }
}
